import wineStroll2018 from './wine-stroll-2018';
import stEugeneCamp2019 from './st-eugine-camp-2019';
import newsletterJune2018 from './newsletter-june-2018';
import newsletterSeptember2018 from './newsletter-september-2018';
import newsletterDecember2018 from './newsletter-december-2018';
import newsletterMarch2019 from './newsletter-march-2019';
import brewfest2019 from './brewfest-2019';
import newsletterJuly2019 from './newsletter-july-2019';
import wineStroll2019 from './wine-stroll-2019';
import lentenLetter2021 from './lenten-letter-2021';
import newsletterMay2021 from './newsletter-may-2021';
import wineStroll2021 from './wine-stroll-2021';
import newsletterAugust2021 from './newsletter-august-2021';
import newsletterDecember2021 from './newsletter-december-2021';
import newsletterMarch2022 from './newsletter-march-2022';
import newsletterDecember2022 from './newsletter-december-2022';
import newsletterApril2023 from './newsletter-april-2023';
import newsletterDecember2023 from './newsletter-december-2023';
import newsletterApril2024 from './newsletter-april-2024';
import newsletterDecember2024 from './newsletter-december-2024';
import newsletterApril2025 from './newsletter-april-2025';
import newsletterDecember2025 from './newsletter-december-2025';
import newsletterApril2026 from './newsletter-april-2026';

export default {
  'wine-stroll-2018': wineStroll2018,
  'st-eugine-camp-2019': stEugeneCamp2019,
  'newsletter-june-2018': newsletterJune2018,
  'newsletter-september-2018': newsletterSeptember2018,
  'newsletter-december-2018': newsletterDecember2018,
  'newsletter-march-2019': newsletterMarch2019,
  'brewfest-2019': brewfest2019,
  'newsletter-july-2019': newsletterJuly2019,
  'wine-stroll-2019': wineStroll2019,
  'lenten-letter-2021': lentenLetter2021,
  'newsletter-may-2021': newsletterMay2021,
  'wine-stroll-2021': wineStroll2021,
  'newsletter-august-2021': newsletterAugust2021,
  'newsletter-december-2021': newsletterDecember2021,
  'newsletter-march-2022': newsletterMarch2022,
  'newsletter-december-2022': newsletterDecember2022,
  'newsletter-april-2023': newsletterApril2023,
  'newsletter-december-2023': newsletterDecember2023,
  'newsletter-april-2024': newsletterApril2024,
  'newsletter-december-2024': newsletterDecember2024,
  'newsletter-april-2025': newsletterApril2025,
  'newsletter-december-2025': newsletterDecember2025,
  'newsletter-april-2026': newsletterApril2026,
};
